import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { groupStyles } from '../../EnterCustomFieldsModal.styles';
import EnterCustomFieldsModalTargetSection from '../EnterCustomFieldsModalTargetSection';

const EnterCustomFieldsModalTargetGroup = ({
  groupHeader,
  sections,
  formValuesByKey,
  initialFormValuesByKey,
  visibleErrorsByKey,
  isDisabled = false,
  onFieldChange,
  onFieldBlur,
}) => (
  <Box sx={groupStyles}>
    <Typography component="h5" variant="medium16">
      {groupHeader}
    </Typography>
    {sections.map(section => (
      <EnterCustomFieldsModalTargetSection
        definitions={section.definitions}
        errors={visibleErrorsByKey[section.key]}
        formValues={formValuesByKey[section.key] ?? initialFormValuesByKey[section.key]}
        isDisabled={isDisabled}
        key={section.key}
        sectionKey={section.key}
        subHeader={section.subHeader}
        onFieldBlur={onFieldBlur}
        onFieldChange={onFieldChange}
      />
    ))}
  </Box>
);

EnterCustomFieldsModalTargetGroup.propTypes = {
  groupHeader: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      definitions: PropTypes.array.isRequired,
      subHeader: PropTypes.string,
    }),
  ).isRequired,
  formValuesByKey: PropTypes.object.isRequired,
  initialFormValuesByKey: PropTypes.object.isRequired,
  visibleErrorsByKey: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default memo(EnterCustomFieldsModalTargetGroup);
